import { types } from 'mobx-state-tree';

// TODO: add separate field for flag to show next to the item in the menu
const Language = types.model('Language', {
  code: types.identifier,
  name: types.string
});

export default Language;
